import React, { Fragment } from 'react'

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { marNotificationsAction } from '../../redux/actions/notificationsActions'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

dayjs.extend(relativeTime);





const NotificationsBlock = ({ notification, setShowNotifications }) => {

    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.marknotifications)



    const handleDispatch = () => {


        dispatch(marNotificationsAction({ notification_id: notification.id }))
    }



    const handleLink = (target) => {

        if (target === "PRODUCT") {
            return `/products/single-product?id=${notification?.related_product_id}`
        }

        if (target === "ORDER") {
            return `/orders/order-details?order_id=${notification?.related_order_id}`
        }

        if (target === "REPORT") {
            return `/order-reports`
        }

        if (target === "USER") {
            return `/dashboard/user-details?user_id=${notification?.related_user_id}`
        }


    }



    return (
        <Fragment>
            <div className={`flex gap-4 items-start p-4 mb-3 bg-white dark:bg-slate-900 border border-zinc-100 dark:border-slate-800 rounded-xl hover:shadow-lg hover:shadow-zinc-100 dark:hover:shadow-black/20 transition-all relative group
                ${notification?.is_read === 0 ? "border-l-4 border-l-indigo-600" : "border-l-4 border-l-transparent"}`}
            >
                {notification?.is_read === 0 && (
                    <div className="w-2.5 h-2.5 rounded-full bg-indigo-600 absolute top-4 right-4 animate-pulse"></div>
                )}
                
                <div className="flex-shrink-0">
                    <div className={`w-10 h-10 rounded-xl flex-center text-lg
                        ${notification?.type === "INFO" && "text-blue-600 bg-blue-50"}
                        ${notification?.type === "WARNING" && "text-amber-600 bg-amber-50"}
                        ${notification?.type === "ERROR" && "text-red-600 bg-red-50"}
                    `}>
                        {notification?.type === "INFO" && <i className="fa-regular fa-bell"></i>}
                        {notification?.type === "WARNING" && <i className="fa-solid fa-triangle-exclamation"></i>}
                        {notification?.type === "ERROR" && <i className="fa-solid fa-circle-xmark"></i>}
                    </div>
                </div>

                <div className="flex-1 min-w-0">
                    <p className="text-sm text-zinc-800 dark:text-slate-200 font-medium leading-relaxed">
                        {notification?.message}
                    </p>
                    
                    <div className="flex justify-between items-center mt-3">
                        <span className='text-xs text-zinc-400 dark:text-slate-500 font-medium flex items-center gap-1'>
                            <i className="fa-regular fa-clock"></i>
                            {dayjs(notification.created_at).fromNow()}
                        </span>
                        
                        <div className="flex gap-3 items-center">
                            {notification?.is_read === 0 && (
                                <button
                                    onClick={handleDispatch}
                                    disabled={loading}
                                    className={`text-xs font-semibold text-indigo-600 dark:text-indigo-300 hover:text-indigo-800 dark:hover:text-indigo-200 transition-colors disabled:opacity-50`}>
                                    Mark as Read
                                </button>
                            )}
                            <Link
                                to={handleLink(notification?.target)}
                                onClick={() => {
                                    handleDispatch();
                                    setShowNotifications(false);
                                }}
                                disabled={loading}
                                className={`text-xs font-semibold text-zinc-600 dark:text-slate-300 hover:text-zinc-800 dark:hover:text-white transition-colors flex items-center gap-1 disabled:opacity-50`}>
                                View
                                <i className="fa-solid fa-chevron-right text-[10px]"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NotificationsBlock
